import api from '@/api';

import { API_BASE_URL } from '..';

import { PageResultStock } from '@/core/request/PageResultStock';
import {
  StockTransfer,
  StockTransferDetailsResponse,
  StockTransferListRequest,
  StockTransferRequest,
  StockTransferResponse,
} from './Operations.types';

const CONTROLLER_URL = `${API_BASE_URL}/operations`;

export async function list(params?: StockTransferListRequest) {
  const result = (await api.get(
    `${CONTROLLER_URL}/transfers`,
    params,
  )) as unknown;

  return result as PageResultStock<StockTransfer>;
}

export async function transfer(obj: StockTransferRequest) {
  const result = (await api.post(
    `${CONTROLLER_URL}/stock-transfer`,
    obj,
    null,
  )) as unknown;

  return result as StockTransferResponse;
}

export async function detail(id?: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/transfers/${id}`,
    {},
  )) as unknown;

  return result as StockTransferDetailsResponse;
}
